import React from 'react';
import { useStyletron } from 'baseui';
import { Spinner } from 'baseui/spinner';
import { LabelXSmall } from 'baseui/typography';
import { VALIDATION_LOADING_TEXT } from './constants';
import { LoadingContainer } from './styled-components';
export type LoadingIndicatorProps = {
  text?: string;
};
export const LoadingIndicator = ({
  text = VALIDATION_LOADING_TEXT
}: LoadingIndicatorProps) => {
  const [, theme] = useStyletron();
  return <LoadingContainer data-testid="loading-indicator">
      <Spinner $size={theme.sizing.scale500} $color={theme.colors.contentSecondary} />
      <LabelXSmall>{text}</LabelXSmall>
    </LoadingContainer>;
};